<template>
  <VaMenuList>
    <RouterLink
      v-for="item in menuItems" :key="item.textKey"
      :to="item.route"
    >
      <VaMenuItem>
        <div class="w-full text-right text-white">
          {{ t(item.textKey) }}
        </div>
      </VaMenuItem>
    </RouterLink>
  </VaMenuList>
</template>

<script lang="ts" setup>
import { VaMenuItem, VaMenuList } from 'vuestic-ui'
import { useI18n } from 'vue-i18n'
import { useUserStore } from '@/stores/UserStore'
import { computed } from 'vue'

interface MenuItem {
  textKey: string
  route: { name: string }
  disabled?: boolean
}

const userStore = useUserStore()
const { t } = useI18n()

const menuItems = computed((): MenuItem[] => {
  let items: MenuItem[] = []
  if (!userStore.isLoggedIn) {
    items = [
      { textKey: 'menu.login', route: { name: 'login' } },
      { textKey: 'menu.apply', route: { name: 'apply' } },
    ]
  } else {
    items = [
      { textKey: 'menu.logout', route: { name: 'logout' } },
    ]
  }

  return items.filter(item => !item.disabled)
})
</script>
